// Generated by ReScript, PLEASE EDIT WITH CARE


var dealerCompanyName = {
  id: "a49abc2e-0ec5-4b81-9f6a-add0b197f05b",
  defaultMessage: "Dealer name"
};

var customerOrderNum = {
  id: "9fde8d3a-8870-4542-93ca-7f4a769b788f",
  defaultMessage: "Order number"
};

var carOrderNum = {
  id: "28793671-05d3-4196-8a25-14d5a2381f93",
  defaultMessage: "Order number"
};

var orderDetail = {
  id: "64244051-7897-44be-b81b-9b2a00f3af3b",
  defaultMessage: "Order details"
};

var lastModification = {
  id: "879ece34-e524-492d-b539-20cc7c45f9d4",
  defaultMessage: "Last modified on"
};

var customerName = {
  id: "e3f60672-fb51-443f-9393-cd4c2ccb7a59",
  defaultMessage: "Customer name"
};

var aquisitionType = {
  id: "c5512be8-5c30-4bca-b891-107d6da7d025",
  defaultMessage: "Acquisition type"
};

var orderDate = {
  id: "7eaae43a-f5c8-43ef-b674-d5f65d869b36",
  defaultMessage: "Order date"
};

var orderDateV2 = {
  id: "bdc1e96b-66a1-442e-bf15-6d41f7abf198",
  defaultMessage: "Order date"
};

var registrationDate = {
  id: "ad2d6872-be18-4f96-ae6f-1773c90b7ab0",
  defaultMessage: "Registration date"
};

var registrationDateV2 = {
  id: "e82410f6-21df-4d4e-aeb8-96d7003d8292",
  defaultMessage: "Registration date"
};

var desiredDelivery = {
  id: "a0e3fbc3-f2f6-4055-8d52-6706eb032465",
  defaultMessage: "Desired delivery"
};

var desiredDeliveryV2 = {
  id: "4ec6d46a-c67a-4390-b599-ba259ea8aa3e",
  defaultMessage: "Desired delivery date"
};

var deliveryDate = {
  id: "b97240dd-c8cd-4e8f-ad5f-9370ce7988eb",
  defaultMessage: "Delivery date"
};

var invoiceDate = {
  id: "d8008f46-db9c-431f-8fc3-f958bd493846",
  defaultMessage: "Renault invoice date"
};

var invoiceDateV2 = {
  id: "825aafda-170c-44df-9131-821fde574a3c",
  defaultMessage: "Renault invoice date"
};

var priceRefVN = {
  id: "7a8bf84a-77b9-4dd7-b1ac-c339e016cfc6",
  defaultMessage: "Price ref VN"
};

var priceRefVNV2 = {
  id: "ba407ce2-a502-4d14-a85d-e6dca9fa2802",
  defaultMessage: "PVC HT (Prix réf)"
};

var priceCaHt = {
  id: "8778a000-3de2-4b30-bbee-43bb4cd3531a",
  defaultMessage: "Tarif PVC HT (Prix réf)"
};

var tarifNumber = {
  id: "56b750fd-a633-4fd8-bc0e-f98fd1937451",
  defaultMessage: "Tarif number"
};

var madcDate = {
  id: "20336c15-8dd4-4812-a352-fc1dc2cd0688",
  defaultMessage: "MADC Date"
};

var madaDate = {
  id: "42a07c06-0881-4ede-82c5-e829a6975d83",
  defaultMessage: "MADA date"
};

var invoiceClient = {
  id: "067e3f47-1bb6-44dc-8a67-776a1509db88",
  defaultMessage: "Client invoice"
};

var invoiceClientV2 = {
  id: "d05229e6-edaf-4ac4-9eee-48c0d5df5412",
  defaultMessage: "Customer invoice date"
};

var invoiceNumber = {
  id: "e636a992-b4c1-4041-8790-dbb3bcbcd09b",
  defaultMessage: "Customer invoice number"
};

var orderBonuses = {
  id: "91ef832c-8fa5-471f-bfab-1b3aed881d64",
  defaultMessage: "Bonuses of the order"
};

var orderBonusesSubtitle = {
  id: "37265e72-c57f-46a0-9f68-a73b1abfc6cd",
  defaultMessage: "View bonuses for this order"
};

var addUnexistActionButton = {
  id: "a1dda4a8-0026-4863-b118-67b7d67b7a47",
  defaultMessage: "Derogate an action not assigned to this order"
};

var actionAmount = {
  id: "df4802e1-27e7-475c-ace0-f370e049e646",
  defaultMessage: "Bonus amount HT"
};

var reprPoliceNumber = {
  id: "b6fd2a3d-857e-4df8-a65b-0892430932a1",
  defaultMessage: "Police number"
};

var reprImmat = {
  id: "17d093a3-f26d-4160-8faf-64ebcdf43a89",
  defaultMessage: "Registration"
};

var reprDateImmat = {
  id: "37da6839-560c-4077-a08d-032c4eeb375b",
  defaultMessage: "Last registration date"
};

var reprDatePremiere = {
  id: "a506e88d-d8bc-4823-84ae-64d436318e30",
  defaultMessage: "First circulation date"
};

var showMore = {
  id: "305127e1-2b52-463d-951b-cb374de59638",
  defaultMessage: "Show more"
};

var showLess = {
  id: "7980e9ac-2522-4432-81cc-f4576b558716",
  defaultMessage: "Show less"
};

var modifySuccess = {
  id: "f9cdb0f7-eda0-4d6a-9309-6cff792f5d0d",
  defaultMessage: "Police number updated successfully"
};

var policeNumberEditTitle = {
  id: "33492420-2ec4-4a67-96d2-bf2cc0769c52",
  defaultMessage: "Enter police number"
};

var enterPoliceNumber = {
  id: "0cd6ebe4-c658-497f-8074-60e8a71b0832",
  defaultMessage: "Enter police number"
};

var finalCustomer = {
  id: "24e8907e-b72e-4523-a43c-c2155b76a11b",
  defaultMessage: "Final customer VAT reg. code"
};

var finalCustomerName = {
  id: "049e37c3-0e23-479c-a5ff-f2bf7672cc66",
  defaultMessage: "Final customer name"
};

var correct = {
  id: "2adfc1a2-141f-463d-87d3-f5e9fb9b3be9",
  defaultMessage: "Correction"
};

var registrationNumber = {
  id: "f9177b9e-55f0-4e0d-9040-d10a11651697",
  defaultMessage: "Registration number"
};

var historyLink = {
  id: "06707aed-e80b-4466-a69a-4d3a4641dec1",
  defaultMessage: "View history of corrections"
};

var lastModifShort = {
  id: "b7bbba26-8b6f-449a-8c32-713b915d18bc",
  defaultMessage: "Last modification"
};

var lastModifShortV2 = {
  id: "99dcd338-7e78-4494-91d5-5ff2818a0261",
  defaultMessage: "Last modification date"
};

var preinvoiceDate = {
  id: "108b508c-8ae9-4b4b-9c24-6880dc622183",
  defaultMessage: "Preinvoice date"
};

var preinvoiceNumber = {
  id: "50e829ef-288e-4cec-a991-456c12f19a8c",
  defaultMessage: "Preinvoice number"
};

var bapInvoiceDate = {
  id: "1a777a24-aab0-485b-86be-6cf3c39007b2",
  defaultMessage: "BAP Date"
};

var zeroBudgetText = {
  id: "0e26454b-17d1-41d8-ad3e-07d70b95cb3f",
  defaultMessage: "No additional bonus"
};

var agentName = {
  id: "e4012251-7a21-4bda-87ef-f9aeb7fcfb31",
  defaultMessage: "Agent name"
};

var calculableWithAmount = {
  id: "2b7baf03-ff73-4bbb-90f5-7ed8d778489c",
  defaultMessage: "To be calculated"
};

var cancellationDate = {
  id: "0d369ee6-36cb-4dcc-a4bc-449d1b75bb75",
  defaultMessage: "Cancellation date"
};

var contractIDOrder = {
  id: "1406024e-5615-47f7-96b8-72a335b7ddc1",
  defaultMessage: "Code protocol"
};

var contractIDOrderV2 = {
  id: "8d912ac6-d672-43ab-a2b2-ed584a3abb6c",
  defaultMessage: "Contract"
};

var oldVehicleInfo = {
  id: "7d3692ab-b98b-4070-a551-09e567e3efed",
  defaultMessage: "Used car information"
};

var validation = {
  id: "1f98ed05-ffac-4487-97fd-ff3d31c2966e",
  defaultMessage: "Validation: "
};

var refusal = {
  id: "ec8c10c4-6a7c-467f-94db-f4bfcb4ddf65",
  defaultMessage: "Refusal:"
};

var validationWithoutInfo = {
  id: "28fa950b-bf43-4ced-b8fe-53ad79ee4557",
  defaultMessage: "Validated"
};

var refusalWithoutInfo = {
  id: "320c8c77-4868-4e61-b5cf-eb7227e33dcd",
  defaultMessage: "Refused"
};

var missingFieldVOSingular = {
  id: "2f7d53a7-03f3-497a-bdcd-5b19445ff2b3",
  defaultMessage: "The field in red must be filled in"
};

var missingFieldsVOPlural = {
  id: "a45c95f5-3aa0-4f70-8c34-58799292ddd3",
  defaultMessage: "The fields in red must be filled in"
};

var dealerName = {
  id: "522f5bd8-891b-4b7e-bbe5-543dca6f005f",
  defaultMessage: "Dealer name"
};

var valueVO = {
  id: "485c68f2-7884-4a10-8ce3-43cabe63adb9",
  defaultMessage: "Trade-in value of used car"
};

var estimatedValueVO = {
  id: "d34f5a97-46ae-432f-b248-f3f12dfb5a5c",
  defaultMessage: "Estimated value of the trade-in"
};

var endOfLifeVO = {
  id: "8a647d44-c218-434e-94fa-fac289ea41a6",
  defaultMessage: "Vehicle end of life (y/n)"
};

var clientFirstName = {
  id: "3f1db6d4-bca6-4310-91d6-3dd0af96f790",
  defaultMessage: "First name"
};

var dateInputParc = {
  id: "f9e3189f-058c-448c-9502-984d5eadad49",
  defaultMessage: "PARC Entry date"
};

var dateOutputParc = {
  id: "4301bdbf-6c48-49dd-a7de-79d2ca8657d7",
  defaultMessage: "PARC Release date"
};

var renaultInvoiceNumber = {
  id: "233b27bc-c08c-4ecf-be2d-1a0afcf7547c",
  defaultMessage: "Renault invoice number"
};

var pvcTtc = {
  id: "a6415753-87fc-4019-a4ed-26c398fb22ea",
  defaultMessage: "PVC TTC"
};

var priceCaTTC = {
  id: "bd9625a2-c2f2-4318-8379-693d1432ad2f",
  defaultMessage: "Tarif PVC TTC"
};

var pvrHt = {
  id: "d3cbbc2f-1175-4eac-a83d-f906070fa049",
  defaultMessage: "PVR HT"
};

var actionAmountPaid = {
  id: "ff7a60ef-9f54-417c-aba2-426821fabe6d",
  defaultMessage: "Amount paid HT"
};

var actionAmountWithVAT = {
  id: "6dc85caa-43b9-4381-ae9d-860ab895490e",
  defaultMessage: "Action amount VAT"
};

var orderIsCanceled = {
  id: "f23d785f-5c90-4ad1-a391-383539c6e609",
  defaultMessage: "Order is cancelled"
};

var waitingForData = {
  id: "b481e32a-b3a8-4ab7-a6c6-3874f4ac83a7",
  defaultMessage: "Waiting for additional data"
};

var waitingForDataVINMissingNotDelivered = {
  id: "03832805-e469-4db6-8012-c49b261aa803",
  defaultMessage: "Waiting for vehicle assignment"
};

var waitingForDataVINNotMissingAndNotDelivered = {
  id: "b4832433-4814-41f9-a69e-a2f14c731f07",
  defaultMessage: "Awaiting delivery"
};

var pending = {
  id: "03f8a4ad-d0fe-42b7-9f4f-a9f56a9486f5",
  defaultMessage: "In progress"
};

var confirmEditModalTitle = {
  id: "dcfd22d7-7649-4f0a-8647-b26773b13069",
  defaultMessage: "Are you sure of the amount entered?"
};

var confirmEditVOModalTitle = {
  id: "c149e914-92c1-4022-a786-c05d04146bc4",
  defaultMessage: "Are you sure about your entry?"
};

var policeNumberNotPresent = {
  id: "26ffcc47-8465-4053-bedf-f8b487a7c8f4",
  defaultMessage: "Police number not present"
};

var waitingForManufacturerFacturation = {
  id: "b75aa7b4-7c56-4ed5-b877-8cb583eb9259",
  defaultMessage: "Waiting for manufacturer invoice"
};

var enterOneEuroCustomerDiscount = {
  id: "227c9670-89ba-450c-b25d-52ae43e7b5a0",
  defaultMessage: "If there is no discount, please enter an amount equal to €1"
};

var entryDateParc = {
  id: "d67d4dcb-c664-4aa4-981f-b25da9c610c2",
  defaultMessage: "Date entry parc"
};

var exitDateParc = {
  id: "a0600c02-a8c9-41cd-a51a-74f28c0df9d6",
  defaultMessage: "Park release date"
};

var deleteAllVOModal = {
  id: "98edb9fe-15e6-48bf-93c6-4c1719602c9a",
  defaultMessage: "Are you sure you want to delete VO information?"
};

var confirmEditExitParc = {
  id: "53b2e002-4596-497c-8a5e-da62068baeea",
  defaultMessage: "Are you sure you want to remove the vehicle from PARC?"
};

var editVO = {
  id: "eaafabe0-00ef-4154-a19d-08ca1ff0e502",
  defaultMessage: "Edit UC"
};

var addDealerRequest = {
  id: "b12e50c8-d0b4-405b-b1db-46e7cf184ccb",
  defaultMessage: "Request additional bonus on the order"
};

var dealerEditParcExitWarning = {
  id: "5cf52a89-d102-440d-9401-6c7723865fbc",
  defaultMessage: "Please note that exit PARC will be definitive"
};

var orderResellingCreateButton = {
  id: "4ca9d6a7-08a6-4d91-9fb7-fc89c0e0feeb",
  defaultMessage: "Create a reselling"
};

var orderResellingRedirectButton = {
  id: "0ea9467b-86ed-4ea0-a60f-bed68a869b10",
  defaultMessage: "Redirect to the resseling order"
};

var deleteResellingOrder = {
  id: "a1c4c66e-cd22-4c91-a12e-2d6245ea59d7",
  defaultMessage: "Are you sure you want to delete the order?"
};

var editOrder = {
  id: "dc18e478-c8f4-4fbe-aa0a-300231ece558",
  defaultMessage: "Update reselling order"
};

var customerDiscountPositive = {
  id: "b2c4c23c-4ddb-4528-ab55-79d6330fd4ac",
  defaultMessage: "Customer discount must be positive"
};

var reselingOrderDetail = {
  id: "002f5e9e-4c61-4491-8fd8-d38971911645",
  defaultMessage: "Detail of reselling order"
};

var orderDateNotInParcPeriod = {
  id: "033bab31-665f-4495-9869-69b06936889c",
  defaultMessage: "The chosen date is not valid. Please set a date within the previous month related to exit PARC and not later than the exit PARC"
};

var deliveryDateBeforeExitParc = {
  id: "e6428f72-8717-4a9b-a45b-8cf112b1e895",
  defaultMessage: "The chosen date is not valid. Please select at least a date occurring after the PARC release date"
};

var resellingModalTitle = {
  id: "b91efc24-145e-48e0-8074-97bc596f96de",
  defaultMessage: "Declare a reselling"
};

var resellingRecipient = {
  id: "6491285e-7340-465c-9d97-18e0ff27c392",
  defaultMessage: "Reselling recipient"
};

var resellingEP = {
  id: "f00aa0e6-c645-48b9-a931-d0ddf6406633",
  defaultMessage: "EP - Private Trial (resale to a private client)"
};

var resellingES = {
  id: "7ec40056-c5a3-46dc-97ac-2228239818b1",
  defaultMessage: "ES - Company Trial (resale to a corporate client)"
};

var resellingRP = {
  id: "263ad7de-4ae9-45b8-a3aa-2abc2e1626df",
  defaultMessage: "RP - Rental Private (resale to a private client)"
};

var resellingRS = {
  id: "cb96bf62-693b-49f7-8108-c60fb14b69f8",
  defaultMessage: "RS - Company Rent (resale to a corporate client)"
};

var resellingAS = {
  id: "9883c1f7-70e3-4757-97e7-d8c03dd07f8b",
  defaultMessage: "AS - Company Agent (resale to a corporate client)"
};

var resellingAP = {
  id: "2ed207f2-1da1-4f26-b59d-b57639bd2385",
  defaultMessage: "AP - Private Agent (resale to a private client)"
};

var enterExitParcNoResell = {
  id: "5e3dc0da-d04e-43c5-b976-1b0082f910bc",
  defaultMessage: "No reselling, only PARC VO entry"
};

var areYouSureNoReselling = {
  id: "376ee5e7-0426-4bc8-9f84-5e86dc41fdbc",
  defaultMessage: "Are you sure you do not want to declare a reselling?"
};

var noResellingWarning = {
  id: "930d4d8e-d533-4d47-be61-3e9ffae2df5d",
  defaultMessage: "Are you sure about your choice? Note that if the 'No reselling, only PARC VO entry' option has been selected, no reversal will be possible"
};

var siretNotActiveOrWrong = {
  id: "ebf5fbef-88f6-474f-858c-6279020fe3fb",
  defaultMessage: "The SIRET you entered is incorrect or inactive"
};

var makeResellingConfirm = {
  id: "58455bd5-b400-4842-ae2f-3a03c13f88e2",
  defaultMessage: "Are you sure you want to validate your reselling declaration?"
};

var sirenNotExist = {
  id: "ab617f42-5a54-4f90-a5a7-f8be3aed955a",
  defaultMessage: "The SIREN you have entered is incorrect"
};

var parcExitDeleteTitle = {
  id: "7064a616-d725-4a14-9f22-25e3722b35b7",
  defaultMessage: "Are you sure you want to delete the PARC release date"
};

var parcExitDeleteWarning = {
  id: "86dc3940-71e1-40b4-801d-5e53c64c9222",
  defaultMessage: "Are you sure about your choice? Note that deleting the PARC release date will result in the cancellation of the resale"
};

var sellerIPN = {
  id: "8e18396f-32b3-41aa-8d88-4adac4cb4e99",
  defaultMessage: "Seller (IPN)"
};

var attributionDateVin = {
  id: "b8b61db0-9f9b-49a8-9d64-663553256fab",
  defaultMessage: "VIN attribution date"
};

var dateLowerThatOrderDate = {
  id: "3b3b63ab-ea45-4091-b2d6-8ea19aad5dfa",
  defaultMessage: "Date lower than order date"
};

export {
  dealerCompanyName ,
  customerOrderNum ,
  carOrderNum ,
  orderDetail ,
  lastModification ,
  customerName ,
  aquisitionType ,
  orderDate ,
  orderDateV2 ,
  registrationDate ,
  registrationDateV2 ,
  desiredDelivery ,
  desiredDeliveryV2 ,
  deliveryDate ,
  invoiceDate ,
  invoiceDateV2 ,
  priceRefVN ,
  priceRefVNV2 ,
  priceCaHt ,
  tarifNumber ,
  madcDate ,
  madaDate ,
  invoiceClient ,
  invoiceClientV2 ,
  invoiceNumber ,
  orderBonuses ,
  orderBonusesSubtitle ,
  addUnexistActionButton ,
  actionAmount ,
  reprPoliceNumber ,
  reprImmat ,
  reprDateImmat ,
  reprDatePremiere ,
  showMore ,
  showLess ,
  modifySuccess ,
  policeNumberEditTitle ,
  enterPoliceNumber ,
  finalCustomer ,
  finalCustomerName ,
  correct ,
  registrationNumber ,
  historyLink ,
  lastModifShort ,
  lastModifShortV2 ,
  preinvoiceDate ,
  preinvoiceNumber ,
  bapInvoiceDate ,
  zeroBudgetText ,
  agentName ,
  calculableWithAmount ,
  cancellationDate ,
  contractIDOrder ,
  contractIDOrderV2 ,
  oldVehicleInfo ,
  validation ,
  refusal ,
  validationWithoutInfo ,
  refusalWithoutInfo ,
  missingFieldVOSingular ,
  missingFieldsVOPlural ,
  dealerName ,
  valueVO ,
  estimatedValueVO ,
  endOfLifeVO ,
  clientFirstName ,
  dateInputParc ,
  dateOutputParc ,
  renaultInvoiceNumber ,
  pvcTtc ,
  priceCaTTC ,
  pvrHt ,
  actionAmountPaid ,
  actionAmountWithVAT ,
  orderIsCanceled ,
  waitingForData ,
  waitingForDataVINMissingNotDelivered ,
  waitingForDataVINNotMissingAndNotDelivered ,
  pending ,
  confirmEditModalTitle ,
  confirmEditVOModalTitle ,
  policeNumberNotPresent ,
  waitingForManufacturerFacturation ,
  enterOneEuroCustomerDiscount ,
  entryDateParc ,
  exitDateParc ,
  deleteAllVOModal ,
  confirmEditExitParc ,
  editVO ,
  addDealerRequest ,
  dealerEditParcExitWarning ,
  orderResellingCreateButton ,
  orderResellingRedirectButton ,
  deleteResellingOrder ,
  editOrder ,
  customerDiscountPositive ,
  reselingOrderDetail ,
  orderDateNotInParcPeriod ,
  deliveryDateBeforeExitParc ,
  resellingModalTitle ,
  resellingRecipient ,
  resellingEP ,
  resellingES ,
  resellingRP ,
  resellingRS ,
  resellingAS ,
  resellingAP ,
  enterExitParcNoResell ,
  areYouSureNoReselling ,
  noResellingWarning ,
  siretNotActiveOrWrong ,
  makeResellingConfirm ,
  sirenNotExist ,
  parcExitDeleteTitle ,
  parcExitDeleteWarning ,
  sellerIPN ,
  attributionDateVin ,
  dateLowerThatOrderDate ,
}
/* No side effect */
